import styled from "styled-components";

export const DishContents = styled.div`
    display:block;
    overflow: hidden;
    width:100%;
    text-align:left;
    font-size: 14px;
    font-weight: 400;
    line-height: 15px;
`;

export const DishContentsText = styled.span<any>`
    color: rgba(255, 255, 255, 0.5);
`;

export const Seperator = styled.span<any> `
    color: #A8A8A8;
`

export const DishContentHighlightedText = styled.span`
    color: #FF6B4B;
`;